'use client';

import { Box } from '@wishket/design-system';
import Link from 'next/link';
import Image from 'next/image';
import { twMerge } from 'tailwind-merge';
import { useState } from 'react';

import { advertisementSize } from './Advertisement.constants';
import { AdTag } from './Advertisement.parts';
import { AdvertisementProps } from './Advertisement.types';

const Advertisement = ({
  imgSrc,
  link,
  variant,
  onClick,
}: AdvertisementProps) => {
  const { width, height, ImageClassName } = advertisementSize[variant];
  const [isError, setIsError] = useState(false);

  const handleImageLoadError = () => {
    console.error('Advertisement image loading failed');
    setIsError(true);
  };

  if (isError) {
    return null;
  }

  return (
    <Link
      href={link}
      className="relative flex w-fit"
      target="_blank"
      onClick={onClick}
    >
      <Box className="absolute right-[18px] top-4">
        <AdTag />
      </Box>
      <Image
        src={imgSrc}
        onError={handleImageLoadError}
        width={width}
        height={height}
        alt="advertisement"
        className={twMerge(
          'rounded-2xl border border-w-gray-200',
          ImageClassName
        )}
        unoptimized
      />
    </Link>
  );
};

export default Advertisement;
